import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import { Above } from '@jetshop/ui/Breakpoints';
import theme from '@jetshop/ui/utils/theme';
import React, { Component } from 'react';
import styled from 'react-emotion';
import { ModelSelectorConsumer } from '../ModelSelector/ModelSelectorProvider';

import CategoryContainer from './CategoryContainer';
import CategorySidebar from './CategorySidebar';
import Filters from './Filters';

import FilterContext from '@jetshop/core/components/Filters/FilterContext';

import { useChannel } from '../../hooks/useChannel';
import CategoryHeaderLoadingState from './CategoryHeaderLoadingState';
import { SharedCartPage } from './SharedCart/SharedCartPage';

const CategoryWrapper = styled('div')`
  width: 100%;
  max-width: ${theme('general.maxWidth')};
  margin: 0 auto;
  display: flex;
  ${theme('below.md')} {
    display: block;
  }
`;

const ChacheHit = () => <CategoryHeaderLoadingState />;

export class ProductsPerPageFix extends Component {
  componentDidMount() {
    this.props.setProductsPerPage(this.props.perPage || 50);
  }
  render() {
    return <div />;
  }
}

const hasSelector = (filters) => {
  return filters.some(
    (f) =>
      f.id.includes('skoter-guide') ||
      f.id.includes('atv-guide') ||
      f.id.includes('cross-guide') ||
      f.id.includes('MC-Guiden')
  );
};

const hasMultiList = (filters) => {
  return filters.find(function (filter) {
    return filter.__typename === 'MultiListFilter';
  });
};

const BannerImage = styled('div')`
  background-image: ${(props) => `url(${props.backgroundImage})`};
  background-color: ${(props) => `${props.backgroundColor}`};
  background-position: ${(props) => `${props.backgroundPosition}`};
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 182px;
`;

function Category({ category, cacheHit, result: { data, loading } }) {
  if (!category) return null;
  if (category.id === 15377) {
    return <SharedCartPage category={category} />;
  }

  const backgroundImage = data?.route?.object?.data?.items.find(
    (item) => item.type === 'Bakgrundsbild'
  )?.properties;

  const backgroundImageUrl = backgroundImage?.find(
    (property) => property.name === 'imageUrl'
  )?.value?.value;
  const backgroundColor = backgroundImage?.find(
    (property) => property.name === 'backgroundColor'
  )?.value?.value;
  const backgroundPosition = backgroundImage?.find(
    (property) => property.name === 'imagePosition'
  )?.value?.value;

  const categoryHasSelector = category?.products?.filters
    ? hasSelector(category.products.filters)
    : false;
  const categoryHasMultiList = category?.products?.filters
    ? hasMultiList(category.products.filters)
    : false;
  const { isWeAhl } = useChannel();

  const categoryId = category?.parentId || category?.id;
  if (!categoryId) return null;

  return (
    <React.Fragment>
      <PaginationContext.Consumer>
        {() => (
          <FilterContext.Consumer>
            {({ applyFilters, activeFilters, clearFilters }) => (
              <React.Fragment>
                <Above breakpoint="md">
                  {(matches) => {
                    if (!cacheHit) return null;

                    return categoryHasMultiList ? (
                      <ModelSelectorConsumer>
                        {({ modelCategory, selectCategory, toggleFilter }) => (
                          <Filters
                            backgroundImageUrl={backgroundImageUrl}
                            backgroundColor={backgroundColor}
                            backgroundPosition={backgroundPosition}
                            selectCategory={selectCategory}
                            activeFilters={activeFilters}
                            applyFilters={applyFilters}
                            clearFilters={clearFilters}
                            modelCategory={modelCategory}
                            toggleFilter={toggleFilter}
                            filters={category.products.filters}
                            sortOrders={category?.products?.sortOrders ?? []}
                            catContent={
                              category.id === 106 ? category.content : ''
                            }
                            catId={categoryId}
                            hasSelector={categoryHasSelector}
                          />
                        )}
                      </ModelSelectorConsumer>
                    ) : matches && (backgroundImageUrl || backgroundColor) ? (
                      <BannerImage
                        backgroundImage={backgroundImageUrl}
                        backgroundColor={backgroundColor}
                        backgroundPosition={backgroundPosition}
                      />
                    ) : null;
                  }}
                </Above>
                <CategoryWrapper
                  data-channel={isWeAhl ? 'Eyewearstore' : 'Skoterdelen'}
                >
                  <Above breakpoint="md" render={() => <CategorySidebar />} />
                  {!cacheHit ? (
                    <ChacheHit />
                  ) : (
                    <CategoryContainer
                      testing={'test'}
                      activeFilters={activeFilters}
                      category={category}
                      loading={loading}
                      data={data}
                      filters={category.products.filters}
                      hasSelector={categoryHasSelector}
                    />
                  )}
                </CategoryWrapper>
              </React.Fragment>
            )}
          </FilterContext.Consumer>
        )}
      </PaginationContext.Consumer>
    </React.Fragment>
  );
}

export default Category;
